import * as React from "react";
import IconButton from "@mui/material/IconButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate } from "react-router-dom";

const ROOT_PATH = "/";

export default function GoBackButton() {
  const location = useLocation();
  const navigate = useNavigate();
  const [hasHistory, setHasHistory] = React.useState(true);

  React.useEffect(() => {
    const handlePopState = () => {
      setHasHistory(true);
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  const handleGoBack = () => {
    window.history.back();
    
    setTimeout(() => {
      if (window.location.pathname === location.pathname) {
        navigate('/');
      }
    }, 100);
  };

  const showBackButton = location.pathname !== ROOT_PATH;

  if (!showBackButton) return null;

  return (
    <IconButton
      onClick={handleGoBack}
      aria-label="Go back"
      sx={{ 
        color: 'primary.main',
        backgroundColor: 'white',
        '&:hover': {
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
        }
      }}
    >
      <ArrowBackIcon />
    </IconButton>
  );
}
